export function Divider(props: { className?: string; }) {
    return (
        <div className={ props.className }>
            <div className='border-b opacity-60'></div>
        </div>
    );
}   